import {
	firebase,
	postsCollection,
	storage,
	usersCollection,
} from '../../config/firebase';

let state = {
	post: {},
	posts: [],
	totalPosts: -1,
	postEvents: [],
	lastSnapshot: '',
	featuredPosts: [],
	loading: false,
	moreLoading: false,
	notification: { message: '', type: '' },
};
let getters = {
	post: state => state.post,
	posts: state => state.posts,
	totalPosts: state => state.totalPosts,
	postEvents: state => state.postEvents,
	postLoading: state => state.loading,
	morePostLoading: state => state.moreLoading,
	postNotification: state => state.notification,
};
let actions = {
	async getPost({ commit }, payload) {
		commit('setPostLoading', true);
		let postSnap = await postsCollection.doc(payload).get();
		let postData = postSnap.data();
		commit('setPostData', postData);
		commit('setPostLoading', false);
	},
	async getPosts({ commit }, payload) {
		commit('setPostLoading', true);
		let lastSnapshot = '';
		postsCollection
			.orderBy('datetime', 'desc')
			.where('user_id', 'in', payload)
			.limit(5)
			.onSnapshot(async snapshot => {
				commit('resetLastSnapShot');
				let posts = [];
				for (let doc of snapshot.docs) {
					let data = doc.data();
					data.comments.reverse();
					let { comments } = data;
					let { user_id } = data;
					let userSnap0 = await usersCollection.doc(user_id).get();
					let userData0 = userSnap0.data();
					if (data.media) {
						data["media_type"] = await storage
						  .refFromURL(data.media)
						  .getMetadata();
						data["media_type"] = data["media_type"].contentType.split("/")[0];
					  }
					data['profile_image'] = userData0.profile_image;
					data['name'] =
						userData0.firstname + ' ' + userData0.lastname;
					data['creator_type'] = userData0.creator_type;
					for (let comment of comments) {
						let { comment_by } = comment;
						let userSnap = await usersCollection
							.doc(comment_by)
							.get();
						let userData = userSnap.data();
						comment['profile_image'] = userData.profile_image;
						comment['comment_by'] =
							userData.firstname + ' ' + userData.lastname;
						comment['username'] = userData.username;
					}
					data.comments = comments;
					posts.push({
						id: doc.id,
						...data,
					});
				}
				lastSnapshot = snapshot.docs[snapshot.docs.length - 1];
				commit('setPostsData', { posts, lastSnapshot });
				commit('setPostLoading', false);
			});
	},
	async getTotalPosts({ commit }, payload) {
		commit('setPostLoading', true);
		let lastSnapshot = '';
		postsCollection
			.orderBy('datetime', 'desc')
			.where('user_id', '==', payload)
			.onSnapshot(snapshot => {
				let size = snapshot.size;
				commit('setTotalPostsData', size);
				commit('setPostLoading', false);
			});
	},
	async getMorePosts({ commit, state }, payload) {
		commit('setMorePostLoading', true);
		let lastSnapshot = '';
		postsCollection
			.orderBy('datetime', 'desc')
			.where('user_id', '==', payload)
			.startAfter(state.lastSnapshot)
			.limit(5)
			.onSnapshot(async snapshot => {
				let posts = [];
				for (let doc of snapshot.docs) {
					let data = doc.data();
					data.comments.reverse();
					let { comments } = data;
					let { user_id } = data;
					
					let userSnap0 = await usersCollection.doc(user_id).get();
					let userData0 = userSnap0.data();
					data['profile_image'] = userData0.profile_image;
					data['name'] =
						userData0.firstname + ' ' + userData0.lastname;
					data['creator_type'] = userData0.creator_type;
					if (data.media) {
						data["media_type"] = await storage
						  .refFromURL(data.media)
						  .getMetadata();
						data["media_type"] = data["media_type"].contentType.split("/")[0];
					  }
					for (let comment of comments) {
						let { comment_by } = comment;
						let userSnap = await usersCollection
							.doc(comment_by)
							.get();
						let userData = userSnap.data();
						comment['profile_image'] = userData.profile_image;
						comment['comment_by'] =
							userData.firstname + ' ' + userData.lastname;
						comment['username'] = userData.username;
					}
					data.comments = comments;
					posts.push({
						id: doc.id,
						...data,
					});
				}

				lastSnapshot = snapshot.docs[snapshot.docs.length - 1];
				commit('setPostsData', { posts, lastSnapshot });
				commit('setMorePostLoading', false);
			});
	},
	async getEvents({ commit }, payload) {
		commit('setMorePostLoading', true);
		postsCollection
			.where('type', '==', 'event')
			.where('user_id', '==', payload)
			.onSnapshot(snapshot => {
				let events = [];
				for (let doc of snapshot.docs) {
					events.push({ id: doc.id, ...doc.data() });
				}
				commit('setEvents', events);
				commit('setMorePostLoading', false);
			});
	},
	async addPost({ commit }, payload) {
		commit('setPostLoading', true);
		let media = payload.media;
		if (media) {
			delete payload.media;
		}
		try {
			let uniqueId = postsCollection.doc().id;
			if (media) {
				let fileNameParts = media.name.split('.');
				let fileExt = fileNameParts[fileNameParts.length - 1];
				let filename = `${uniqueId}.${fileExt}`;

				await storage.ref(`/post/${filename}`).put(media);
				payload['media'] = await storage
					.ref('post')
					.child(filename)
					.getDownloadURL();
			}
			payload['hashtags'] = [];
			payload['comments'] = [];
			payload['likes'] = [];
			payload['datetime'] = firebase.firestore.Timestamp.fromDate(
				new Date()
			);
			if (payload['type'] == 'thought') {
				payload['hashtags'] = payload['thought'].match(
					/#[0-9a-zA-Z]*/g
				);
			}
			if (payload['type'] == 'media') {
				payload['hashtags'] = payload['description'].match(
					/#[0-9a-zA-Z]*/g
				);
			}
			
			await postsCollection.doc(uniqueId).set(payload);
			commit('setPostsNotification', {
				message: 'Post Added',
				type: 'success',
			});
		} catch (err) {
			commit('setPostsNotification', {
				message: err.message,
				type: 'error',
			});
		} finally {
			commit('setPostLoading', false);
		}
	},
	async addPostComment({ commit, dispatch }, payload) {
		let post_id = payload.post_id;
		let postSnap = await postsCollection.doc(post_id).get();
		delete payload['post_id'];
		let data = postSnap.data();
		let comments = data.comments;
		if (!comments) comments = [];
		comments.push({
			...payload,
			datetime: firebase.firestore.Timestamp.fromDate(new Date()),
		});
		let mentionedUsers = payload['comment'].match(/@[0-9a-zA-Z_]*/g);
		let uniqueMentionedUsers = new Set(mentionedUsers);
		mentionedUsers = Array.from(uniqueMentionedUsers);
		for (let mentionedUser of mentionedUsers) {
			let username = mentionedUser.substring(1);
			
			let userSnap = await usersCollection
				.where('username', '==', username)
				.get();
			let userId = userSnap.docs[0].id;
			
			dispatch('setNotification', {
				message: 'mentioned you in a comment',
				for: userId,
				user: payload.comment_by,
				type: 'mention',
				post_id,
			});
		}
		data['comments'] = comments;
		await postsCollection.doc(post_id).update({ ...data });
	},
	async addPostLike({ commit }, payload) {
		let post_id = payload.post_id;
		let postSnap = await postsCollection.doc(post_id).get();
		delete payload['post_id'];
		let data = postSnap.data();
		let likes = data.likes;
		if (!likes) likes = [];
		if (likes.includes(payload.by)) {
			likes = likes.filter(like => like != payload.by);
		} else {
			likes.push(payload.by);
		}
		data['likes'] = likes;
		await postsCollection.doc(post_id).update({ ...data });
	},
};
let mutations = {
	resetLastSnapShot(state) {
		state.lastSnapshot = '';
		state.posts = [];
	},
	setPostData(state, payload) {
		state.post = payload;
	},
	setTotalPostsData(state, payload) {
		state.totalPosts = payload;
	},
	setEvents(state, payload) {
		state.postEvents = payload;
	},
	setPostsData(state, payload) {
		if (state.lastSnapshot == '') {
			state.posts = payload.posts;
		} else {
			let { posts } = state;
			posts.push(...payload.posts);

			state.posts = posts;
		}
		state.lastSnapshot = payload.lastSnapshot;
	},
	setMorePostLoading(state, payload) {
		state.moreLoading = payload;
	},
	setPostLoading(state, payload) {
		state.loading = payload;
	},
	setPostsNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
